// next
// @mui
import { Box, Link, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { CategoryProps } from 'src/@types/category';
import Routes from 'src/routes';

// ----------------------------------------------------------------------

type Props = {
  categories: CategoryProps[];
};

export default function BlogSidebarCategories({ categories }: Props) {
  const router = useRouter();

  const handleCategory = (name: string | undefined) => {
    name = name?.toLowerCase();
    const options = { scroll: false, shallow: true };

    if (name === undefined) {
      router.push({ pathname: Routes.blog, query: { page: 1 } }, undefined, { ...options });
    } else {
      router.push({ pathname: Routes.blog, query: { page: 1, category: name } }, undefined, { ...options });
    }
  };

  return (
    <Stack spacing={1}>
      <Typography variant="h4" gutterBottom>
        Kategorier
      </Typography>

      <Stack direction="row" alignItems="center">
        <Box
          sx={{
            width: 6,
            height: 6,
            mr: 2,
            bgcolor: !router.query.category ? 'primary.main' : 'text.secondary',
            borderRadius: '50%',
          }}
        />
        <Link
          component="button"
          variant="body2"
          color="inherit"
          onClick={() => handleCategory(undefined)}
        >
          Alle
        </Link>
      </Stack>
      {categories?.map((category: { _id: string; name: string }) => (
        <CategoryItem
          active={category.name.toLowerCase() == router.query.category}
          onClick={(name: string) => handleCategory(name)}
          key={category.name}
          category={category}
        />
      ))}
    </Stack>
  );
}

// ------------------------------------w----------------------------------

type CategoryItemProps = {
  category: CategoryProps;
  active?: boolean;
  onClick: any;
};

function CategoryItem({ category, active, onClick }: CategoryItemProps) {
  const { name } = category;

  return (
    <Stack key={name} direction="row" alignItems="center">
      <Box
        sx={{
          width: 6,
          height: 6,
          mr: 2,
          bgcolor: active ? 'primary.main' : 'text.secondary',
          borderRadius: '50%',
        }}
      />
      <Link component="button" variant="body2" color="inherit" onClick={() => onClick(name)}>
        {name}
      </Link>
    </Stack>
  );
}
